export const BUILD_INFO = {
  buildId: '181191',
  commit: '2098a69'
};
